export const questionsData = [
  {
    id: 1,
    question: "Czy muszę płacić za serwer (hosting) co roku?",
    answer:
      'Nie. To nasza największa przewaga. Twoja strona korzysta z profesjonalnej infrastruktury, dzięki której serwer masz za darmo na zawsze (lub do kiedy współpracujesz własnie z nami). Nie płacisz co miesiąc ani co rok za "utrzymanie systemu". Jedyny koszt to odnowienie domeny (ok. 150 zł rocznie, może zmieniać się w zależności od ceny aktualnej domeny), przy czym pierwszy rok masz już wliczony w cenę strony. Jest to koszt, którego nie unikniesz, niezależnie od tego, z jakim dostawcą współpracujesz. My po prostu oferujemy Ci darmowy hosting, co jest ogromną oszczędnością w porównaniu do innych rozwiązań na rynku.',
  },
  {
    id: 2,
    question: "Skąd bierze się tak krótki czas realizacji (96h)?",
    answer:
      "To kwestia perfekcyjnej optymalizacji. Pracujemy na naszych autorskich fundamentach, które projektowaliśmy od zera przez wiele miesięcy. Zamiast tracić czas na powtarzalne ustawienia techniczne, od razu przechodzimy do personalizacji Twojej marki. Cały proces zamykamy zazwyczaj w 96 godzinach roboczych.",
  },
  {
    id: 3,
    question: "Co w przypadku, gdy będę potrzebować zmian w przyszłości?",
    answer:
      "Gwarantujemy Ci pełne bezpieczeństwo. W cenie otrzymujesz trzy bezpłatne pakiety poprawek, z których możesz skorzystać w ciągu roku od startu strony (np. przy zmianie numeru telefonu czy cennika). Każda kolejna modyfikacja to symboliczny koszt rzędu 10-50 zł – najtaniej na rynku. To rozwiązanie, które daje Ci spokój i pewność, że Twoja strona będzie zawsze aktualna i dostosowana do potrzeb Twojego biznesu, bez obaw o wysokie koszty zmian w przyszłości.",
  },
  {
    id: 4,
    question: "Czy za realizację projektu otrzymam fakturę?",
    answer:
      "Tak. Za każdą usługę wystawiamy fakturę (bez VAT), którą otrzymasz na e-mail. Możesz ją w całości wliczyć w koszty uzyskania przychodu – to najprostsze i najbezpieczniejsze rozwiązanie dla Twojego biznesu. Nie musisz martwić się o żadne dodatkowe formalności, a my zapewniamy Ci pełną transparentność i profesjonalizm w rozliczeniach.",
  },
  {
    id: 5,
    question: "Czemu na Allegro ceny usług są wyższe?",
    answer:
      "Wyższa cena na platformie Allegro wynika wyłącznie z wysokich prowizji i opłat transakcyjnych pobieranych przez operatora. Kontaktując się z nami bezpośrednio, omijasz te dodatkowe koszty i otrzymujesz najlepszą możliwą ofertę przy zachowaniu tej samej jakości i gwarancji. ",
  },
  {
    id: 6,
    question: "Co jeśli nie mam własnych profesjonalnych zdjęć lub tekstów?",
    answer:
      "Bez obaw, zajmiemy się tym. Jeśli brakuje Ci fotografii, wygenerujemy dla Twojej marki unikalne grafiki AI, które idealnie oddadzą klimat Twojego biznesu. Pomożemy Ci też ubrać Twoje pomysły w profesjonalne słowa, aby strona od początku budowała Twoje zaufanie. ",
  },
  {
    id: 7,
    question: "Czy to autorskie projekty, czy gotowce z sieci?",
    answer:
      "Każdy element naszej kolekcji stworzyliśmy sami – od pierwszej linii kodu po ostatni detal wizualny. Nie używamy WordPressa ani ciężkich, powolnych kreatorów stron. Wybierając nas, otrzymujesz unikalny produkt w technologii React.js, a nie masowy szablon, który posiada co druga firma w Twojej branży.",
  },
  {
    id: 8,
    question: "Czy będę mieć pełną kontrolę i dostęp do strony?",
    answer:
      "Jak najbardziej. Przekazujemy Ci napisany kod do Twojej strony. Nasz kod jest czysty i uporządkowany – jeśli kiedykolwiek zdecydujesz się przekazać stronę innemu informatykowi, odnajdzie się on w strukturze bez problemu. Jesteś w 100% niezależna.",
  },
  {
    id: 9,
    question: "Jak strona radzi sobie w wyszukiwarce Google (SEO)?",
    answer:
      'Większość stron to ciężkie projekty na WordPressie, które przez nadmiar zbędnych wtyczek lądują na końcu wyników. Nasze strony budujemy "na lekko", co sprawia, że są błyskawiczne i faworyzowane przez Google. To fundament, który pozwala realnie powalczyć o najwyższe pozycje.',
  },
  {
    id: 10,
    question: "Czy strona będzie bezpieczna (certyfikat SSL)?",
    answer:
      'Tak. Obok adresu Twojej strony zawsze będzie widoczna "zielona kłódka". Certyfikat SSL masz w cenie, co gwarantuje szyfrowanie danych i brak ostrzeżeń w przeglądarkach. Twoja witryna będzie w pełni bezpieczna dla odwiedzających.',
  },
  {
    id: 11,
    question: "Jak nawiązać z nami współpracę?",
    answer:
      "Masz dwie proste drogi. Możesz dokonać zakupu bezpośrednio przez nasz profil na Allegro lub napisać do nas wiadomość e-mail. W odpowiedzi otrzymasz od nas krótką instrukcję i ankietę, która pomoże nam doprecyzować wygląd Twojej nowej strony. Więcej szczegółów na temat całego procesu znajdziesz na naszej podstronie",
    cooperationLink: true,
  },
  {
    id: 12,
    question: "Co jeśli nie mam gotowych treści i nie wiem, co napisać?",
    answer:
      "To najczęstsza obawa, dlatego maksymalnie uprościliśmy ten proces. Nie musisz być pisarzem ani fotografem. Po zakupie otrzymasz od nas prostą ankietę, która 'wyciągnie' od Ciebie najważniejsze informacje o Twoim biznesie. Na ich podstawie przygotujemy profesjonalne teksty, a jeśli brakuje Ci zdjęć – wygenerujemy dla Twojej marki unikalne grafiki AI. Nasza strona jest elastyczna: jeśli nie masz jeszcze cennika czy zespołu, po prostu ukryjemy te sekcje, a całość nadal będzie wyglądać luksusowo i spójnie. Więcej informacji znajdziesz w sekcji",
    cooperationLink: true,
  },
];
